import { render, staticRenderFns } from "./ClientAdmin.vue?vue&type=template&id=506627e5"
import script from "./ClientAdmin.js?vue&type=script&lang=js&external"
export * from "./ClientAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports